import { getCategoricalChartColor } from "../../../styles/theme";
export var NAMED_CHART_COLORS = {
    "10 A 14": "#034EA2",
    "15 A 19": "#0EA5E9",
    "20 A 24": "#6366F1",
    "25 A 29": "#8B5CF6",
    "30 A 34": "#EC4899",
    "35 A 39": "#EF4123",
    "40 A 44": "#F59E0B",
    "40 A 49": "#F59E0B",
    "45 A 59": "#FDB913",
    "50 A 59": "#10B981",
    "50 OU MAIS": "#007932",
    "60 A 69": "#007932",
    "70 OU MAIS": "#7C3AED",
    AMARELA: "#FDB913",
    BRANCA: "#0EA5E9",
    PARDA: "#8B5CF6",
    PRETA: "#EF4123",
    NEGRA: "#EF4123",
    INDIGENA: "#007932",
    INDÍGENA: "#007932",
    MADRUGADA: "#111827",
    MANHA: "#034EA2",
    MANHÃ: "#034EA2",
    TARDE: "#FDB913",
    NOITE: "#7C3AED",
};
export var LEGEND_TEXT_COLOR = "#1F2937";
export var AXIS_TEXT_COLOR = "#374151";
export var BODY_TEXT_COLOR = "#1F2937";
export var PAGE_SIZE = 10;
export var DEAMS_PRIMARY_X_COLUMN = "periodo";
export var DEAMS_PRIMARY_VALUE_COLUMN = "quantidade";
export var DEAMS_INITIAL_VISIBLE_CARDS = 5;
export var DIMMED_OPACITY = 0.2;
export var DEAMS_DIMMED_OPACITY = 0.45;
export var DEAMS_FOCUS_DIMMED_OPACITY = 0.12;
export var MONTH_LABELS_SHORT = [
    "JAN",
    "FEV",
    "MAR",
    "ABR",
    "MAI",
    "JUN",
    "JUL",
    "AGO",
    "SET",
    "OUT",
    "NOV",
    "DEZ",
];
export var normalizeColorKey = function (value) {
    return value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim();
};
export var getChartColor = function (label, index) {
    var _a;
    return (_a = NAMED_CHART_COLORS[normalizeColorKey(label)]) !== null && _a !== void 0 ? _a : getCategoricalChartColor(label, index);
};
